import React from 'react';
import Uganda_s4 from './uganda_s4';
import Uganda_s4_subjects from './uganda_s4_subjects';
const Uganda_s4chi = () => {
  return (
    <div>
      <Uganda_s4 />
    <Uganda_s4_subjects />
    <div className='relative right-0 left-0 top-37 '>
      <h1>Chinese</h1>
      <h3>NFT in the new secondary school curriculum</h3>
      <li>Generic skills or Soft skills or 21st century skills integrated in agriculture learning and assessment </li>
      <li>Cross-cutting isues integrated in Agriculture learning and assessment </li>
      <li>Values integrated in Agriculture learning and assessment </li>
      </div>
    </div>
  );
}

export default Uganda_s4chi;